<template lang="pug">
  transition(name="fade")
    .modal(v-if="isVisible")
      .modal__overlay(@click="close")
      .modal__content
        icon-button.modal__close(label="Close Modal", icon="close", @click="close")
        slot
</template>

<script>
  import Modal from 'scripts/components/basic/Modal.vue'
  import IconButton from 'scripts/components/buttons/IconButton.vue'

  export default {
    name: 'AccountForgotPassword',
    components: { IconButton },
    extends: Modal
  }
</script>

<style lang="scss">
  .login--forgotpw {
    &-header {
      margin-top: 0;
      margin-bottom: 16px;
    }

    &-text {
      margin: 15px 0;
      font-family: $font-gibson;
    }

    &-submit {
      display: block;
    }
  }
</style>

<style lang="scss" scoped>
  .modal__content {
    @include tablet-up {
      max-width: 550px;
    }
  }
</style>
